/**
 * API functions for Anomaly Detection Alerts
 */

import apiClient from './client';

/**
 * Get alerts with optional filtering
 */
export const getAlerts = async ({
  severity = null,
  category = null,
  isRead = null,
  isDismissed = false,
  limit = 50,
  offset = 0
} = {}) => {
  const params = new URLSearchParams();
  
  if (severity) params.append('severity', severity);
  if (category) params.append('category', category);
  if (isRead !== null) params.append('is_read', isRead);
  if (isDismissed !== null) params.append('is_dismissed', isDismissed);
  params.append('limit', limit);
  params.append('offset', offset);
  
  const response = await apiClient.get(`/api/v1/alerts?${params.toString()}`);
  return response.data;
};

/**
 * Get alert summary (counts by severity)
 */
export const getAlertsSummary = async () => {
  const response = await apiClient.get('/api/v1/alerts/summary');
  return response.data;
};

/**
 * Trigger a manual alert scan
 */
export const scanForAlerts = async () => {
  const response = await apiClient.post('/api/v1/alerts/scan');
  return response.data;
};

/**
 * Mark an alert as read
 */
export const markAlertRead = async (alertId) => {
  const response = await apiClient.put(`/api/v1/alerts/${alertId}/read`);
  return response.data;
};

/**
 * Dismiss an alert
 */
export const dismissAlert = async (alertId) => {
  const response = await apiClient.put(`/api/v1/alerts/${alertId}/dismiss`);
  return response.data;
};

/**
 * Mark all alerts as read
 */
export const markAllAlertsRead = async () => {
  const response = await apiClient.put('/api/v1/alerts/read-all');
  return response.data;
};
